const PERSISTED_GROUPS_KEY = "persistedGroups";

export { PERSISTED_GROUPS_KEY };
